import { Box, Typography, Stack, Grid } from '@mui/material';
import colors from 'assets/scss/_themes-vars.module.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <Grid justifyContent="center" alignItems="center" container sx={{ height: '100%' }}>
            <Grid item xs={6} sm={4}>
                <Stack justifyContent="center" spacing={2} alignItems="center">
                    <Typography
                        sx={{
                            fontSize: '6rem',
                            color: colors?.grey900,
                            fontWeight: 800
                        }}
                    >
                        404
                    </Typography>
                    <Box
                        boxShadow={5}
                        sx={{
                            background: 'white',
                            width: 'inherit',
                            p: 2,
                            borderRadius: 3
                        }}
                    >
                        <Typography
                            paragraph
                            sx={{
                                fontSize: '1.5rem',
                                color: colors?.grey700,
                                fontWeight: 800,
                                mb: 0
                            }}
                        >
                            {t('PageNotFound')}
                        </Typography>
                    </Box>
                    <Typography
                        paragraph
                        onClick={() => navigate('/home')}
                        sx={{
                            cursor: 'pointer',
                            '&:hover': {
                                textDecoration: 'underline'
                            },
                            fontSize: '1rem',
                            color: colors?.grey700,
                            fontWeight: 800,
                            mb: 0
                        }}
                    >
                        {t('RedirectToHome')}
                    </Typography>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default PageNotFound;
